import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { FIREBASE_AUTH } from "@dis/firebase";
import { SAMLAuthProvider, linkWithPopup } from "firebase/auth";
import { INNOVEX_SAML_PROVIDER_ID } from "../services/auth.service";

@Component({
  selector: "lib-link-microsoft-button",
  imports: [MatButtonModule],
  templateUrl: "./link-microsoft-button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkMicrosoftButtonComponent {
  readonly buttonText = input("Link Innovex Account");
  readonly disabled = input(false);
  readonly linked = output<void>();
  readonly linkFailed = output<unknown>();

  readonly #auth = inject(FIREBASE_AUTH);
  readonly #isLinking = signal(false);

  readonly isDisabled = computed(() => this.disabled() || this.#isLinking() || !this.#auth.currentUser);
  readonly isLinking = this.#isLinking.asReadonly();

  async linkMicrosoftAccount(): Promise<void> {
    if (this.isDisabled()) {
      return;
    }

    const currentUser = this.#auth.currentUser;
    if (!currentUser) {
      return;
    }

    this.#isLinking.set(true);
    const provider = new SAMLAuthProvider(INNOVEX_SAML_PROVIDER_ID);

    try {
      await linkWithPopup(currentUser, provider);
      this.linked.emit();
    } catch (error) {
      this.linkFailed.emit(error);
    } finally {
      this.#isLinking.set(false);
    }
  }
}
